import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UserApiQuotaService {
    public baseurl = environment.apiUrl;
    private userApiQuotaApi = "api/UserApiQuota/";
    constructor(private http: HttpClient) { }

    SaveUserApiQuota(data) {
        const url = this.baseurl + this.userApiQuotaApi;
        return this.http.post(url, data);
    }

    RefreshAPIToken(data){
    const url = this.baseurl + this.userApiQuotaApi + 'ResetApiKey' + "?id=" + data;
    return this.http.post(url, null);
  }

}
